import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import URLs from '../../../../../utils/appURLs';
import axiosInstance from '../../../../../app/config/axiosInstance';
import { updateToast } from '../../../../../common/redux/reducer/commonSlices/toastSlice';

type ReturnedType = any;

type TrackThunkArg = {
  tripId: string;
};

const initialState = {
  isLoading: false,
  data: [],
  error: null
};

export const tripTrackingAction = createAsyncThunk<ReturnedType, TrackThunkArg>(
  'triptracking',
  async ({ tripId }, thunkApi) => {
    try {
      const response = await axiosInstance({
        method: 'GET',
        url: `${URLs.Trip_Tracking}tripId=${tripId}`
      });
      thunkApi.dispatch(
        updateToast({
          show: true,
          message: response?.data?.message,
          severity: 'success'
        })
      );
      return response;
    } catch (error: any) {
      thunkApi.dispatch(
        updateToast({
          show: true,
          message: error?.response?.data?.error,
          severity: 'error'
        })
      );
      return thunkApi.rejectWithValue(error);
    }
  }
);

// share trips slice
const tripTrackingSlice = createSlice({
  name: 'share trips',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(tripTrackingAction.pending, state => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(
        tripTrackingAction.fulfilled,
        (state, action: PayloadAction<ReturnedType>) => {
          state.isLoading = false;
          state.data = action.payload?.data;
          state.error = null;
        }
      )
      .addCase(tripTrackingAction.rejected, (state, action: any) => {
        state.isLoading = false;
        state.error = action?.payload?.response?.data?.error || 'Something went wrong';
      });
  }
});

export default tripTrackingSlice.reducer;
